import React, { useState } from 'react'
import './RangeSelector.css'

function RangeSelector(props) {
    console.log("RangeSelector",props)
    const [activeLink, setActiveLink] = useState('');
    const { required, max } = props;

    const handleClick = (id) => {
        setActiveLink(id);
        props.onChange(id)
    }
    const getButtons = () => {
        var rows = [];
        for (let index = 0; index <= max; index++) {
            if (index === 0 && required) {
            }
            else {
                rows.push(<button key={index} type="button" className={`${activeLink === index ? 'activeBtn' : null || props.rvalue === index ? 'activeBtn' : null } range-btn`} id={`list-${index}`} onClick={() => { handleClick(index) }}>{index}</button>)
            }
        }
        return rows;
    }

    return (
        <>
            <label style={{ fontSize: '14px', fontWeight: '500' }} htmlFor='range' className='mb-2 mr-2'>{props.label}{required ? <i className="fas fa-asterisk ml-2" style={{ color: '#ff0000ba', fontSize: '8px' }} /> : null}</label><br />

            <div className='range-container' id='range' >
                {
                    getButtons()
                }
            </div>
        </>
    )
}

export default RangeSelector
